import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { translate } from "../../utils/utils";

const DeleteModal = ({
  open,
  handleClose,
  id,
  description,
  title,
  handleDelete,
  buttonLabel,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <Dialog
        disableEnforceFocus
        open={open}
        aria-labelledby="draggable-dialog-title"
        onClose={handleClose}
        PaperProps={{ sx: { padding: "40px 10px ", width: "100%" } }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 2 }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <DialogTitle id="draggable-dialog-title" sx={{ margin: "0px 20px" }}>
          <Typography
            variant="title4"
            sx={{
              fontSize: "25px",
            }}
          >
            {translate(title) || [t("not_specified")]}
          </Typography>
        </DialogTitle>{" "}
        <DialogContent sx={{ margin: "10px 20px" }}>
          <DialogContentText>
            {translate(description) || [t("not_specified")]}
          </DialogContentText>
        </DialogContent>
        <DialogActions align="center">
          <Grid container>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="deleteButton"
                sx={{ width: "90%" }}
                onClick={handleDelete}
              >
                {buttonLabel}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteModal;
